export default "__VITE_ASSET__Bqs_Eacq__"